import { render } from "./CommercialInfoCard.vue?vue&type=template&id=f921f908"
import script from "./CommercialInfoCard.vue?vue&type=script&lang=js"
export * from "./CommercialInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__